var exports = {
  "$": "statistic__ySM1Bn",
};

module.exports = exports;
